import { Formik, FormikHelpers, FormikProps } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Col } from 'react-bootstrap';
import Store from '../../store';
import { emptyCalendarDayoff } from '../../store/initial';
import { InjectedProps } from '../../types';
import { CalendarDayoff } from '../../types/CalendarDayoff';
import ControlButtonSave from '../misc/ControlButtonSave';
import CalendarDayoffForm, { ICalendarDayoffForm } from './CalendarDayoffForm';

interface CalendarDayoffNewProps {
    handleClose: (calendarDayoff: CalendarDayoff) => any;
    store?: Store;
}

@inject('store')
@observer
export class CalendarDayoffNew extends React.Component<CalendarDayoffNewProps> {
    public get injected() {
        return this.props as InjectedProps;
    }

    public initialValues = () => ({ ...emptyCalendarDayoff });

    public render() {
        return (
            <>
                <Col>
                    <Formik
                        initialValues={this.initialValues()}
                        enableReinitialize
                        onSubmit={this.handleSubmit}
                    >{this.renderForm()}</Formik>
                </Col>
            </>
        );
    }

    public renderForm = () => {
        return CalendarDayoffForm({
            editing: true,
            controls: (bag: FormikProps<ICalendarDayoffForm>) => <ControlButtonSave />
        });
    };

    public handleSubmit = (values: any, actions: FormikHelpers<any>) => {
        actions.setSubmitting(true);
        const { calendarsDaysoff, agencyStore } = this.injected.store;
        const { activeAgencyId } = agencyStore;

        if (activeAgencyId) {
            values.agency_id = activeAgencyId;
        }

        const { handleClose } = this.props;
        actions.setSubmitting(false);
        return calendarsDaysoff
            .create(values)
            .then(() => {
                actions.resetForm();
                handleClose(values);
            })
            .catch(error => actions.setErrors(error.response.data));
    };
}

export default CalendarDayoffNew;
